import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../supabase';

function SiteSeal() {
    const navigate = useNavigate();
    const [seal, setSeal] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
    const [hasMounted, setHasMounted] = useState(false);
    const [revealed, setRevealed] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 600);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const fetchSeal = async () => {
            const { data } = await supabase.from('site_seal').select('*').eq('enabled', true).maybeSingle();
            if (data) setSeal(data);
        };
        fetchSeal();
    }, []);

    useEffect(() => {
        const t = requestAnimationFrame(() => setHasMounted(true));
        return () => cancelAnimationFrame(t);
    }, []);

    if (!seal || !seal.image_url) return null;

    const handleClick = () => {
        navigate('/newsletter');
    };

    const size = isMobile ? 110 : 200;
    const hiddenAmount = size * 0.7;
    const restingBottom = isMobile ? 72 : 56;
    const rightOffset = isMobile ? 12 : 24;

    return (
        // Zone de déclenchement FIXE — sa taille et position ne changent jamais,
        // peu importe si le dessin à l'intérieur est révélé ou caché.
        // Ça évite le clignotement quand la souris reste dans cette zone stable
        // pendant que le dessin (lui) glisse vers le haut.
        <div
            onMouseEnter={() => setRevealed(true)}
            onMouseLeave={() => setRevealed(false)}
            onTouchStart={() => setRevealed(true)}
            onTouchEnd={() => setTimeout(() => setRevealed(false), 300)}
            style={{
                position: 'fixed',
                bottom: 0,
                right: `${rightOffset}px`,
                width: `${size}px`,
                height: `${restingBottom + size}px`, // couvre toute la course du glissement, jamais réduite
                zIndex: 40,
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'center',
                pointerEvents: 'auto',
            }}
        >
            <div
                onClick={handleClick}
                style={{
                    width: `${size}px`,
                    height: `${size}px`,
                    marginBottom: `${revealed ? restingBottom : restingBottom - hiddenAmount}px`,
                    cursor: 'pointer',
                    transition: hasMounted ? 'margin-bottom 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)' : 'none',
                }}
            >
                <img
                    src={seal.image_url}
                    alt={seal.alt_text || 'winston.ie'}
                    title={seal.alt_text || ''}
                    style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
                />
            </div>
        </div>
    );
}

export default SiteSeal;